module.exports = __webpack_public_path__ + "img/Rectangle 19.2a8728be.png";